export default __webpack_public_path__ + "static/media/UK01.1.9950c0e3.mp3";